export default __webpack_public_path__ + "0dd3d61875fa85770eb720ed4b61fc9e.png";